var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"staged-rollout-slider"},[_c('ElSlider',{staticClass:"staged-rollout-slider__percentage",attrs:{"value":_vm.percentage,"step":_vm.step,"min":0,"max":100,"format-tooltip":_vm.makeSliderTooltip,"marks":_vm.sliderStopsLabels},on:{"input":_vm.setPercent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }